"use client";
import {
  NetworkError,
  ClientError,
  ClientStatusCodes,
} from "@/lib/utils/error-definitions";
import React, { useEffect, useState } from "react";
import { TGetLewboardGeneration } from "../../b2c-api/src/routers/lewkboards";
import { parseAsInteger, useQueryState } from "nuqs";
import LewkItem from "./c-lewk-item";
import { LewkAPI } from "@/config/api/api-client";

const Lewkbar = () => {
  const [lewkboardList, setLewkboardList] = useState<TGetLewboardGeneration>();
  const [loading, setLoading] = useState<boolean>(false);
  const [genID, setGenID] = useQueryState("genID", parseAsInteger);
  const [currentIndex, setIndex] = useQueryState("index", parseAsInteger);

  // ---------------------------- FUNCTIONS ---------------------------- //
  const fetchLewkboardList = async (lewkboardGenerationID: number) => {
    try {
      setLoading(true);
      const { data, error } =
        // @ts-ignore
        await LewkAPI.lewkboards["get-generation"][lewkboardGenerationID].get();

      // @ts-ignore
      if (error) throw new NetworkError(error.value["error"], error.status);
      setLewkboardList(data);
    } catch (error) {
      if (error instanceof NetworkError) {
        error.handle();
      } else {
        new ClientError(
          "We were not able to fetch the lewkboard list. Please try again later.",
          ClientStatusCodes.UNDOCUMENTED_ERROR
        ).handle();
      }
    } finally {
      setLoading(false);
    }
  };
  // ---------------------------- USE EFFECT ---------------------------- //
  useEffect(() => {
    if (genID) {
      fetchLewkboardList(genID);
    }
  }, [genID]);

  return (
    genID && (
      <div className=" hidden lg:flex flex-col px-4 pt-[46px] items-center gap-2">
        <h1 className="text-heading">LEWK Boards</h1>
        {lewkboardList?.map((lewk, index) => (
          <LewkItem
            key={index}
            {...lewk}
            index={index + 1}
            genID={genID as number}
            size=" lg:size-[100px] xl:size-[150px]"
            selected={index + 1 == currentIndex}
            className={`${index + 1 == currentIndex ? "cursor-default border-lewk-blue border-4 bg-lewk-blue hover:scale-100 text-white rounded-base shadow-container " : ""}`}
          />
        ))}
      </div>
    )
  );
};

export default Lewkbar;
